
import $tenants from 'stores/tenants'
import $global from 'stores/global'
import {ArrowRight} from '@element-plus/icons-vue'
import Users from './users.vue'
import Settings from './settings'
import Files from './files'

export default {
  components: {ArrowRight, Users, Settings, Files},
  data() {
    return {
      loading: true,
      tenant: undefined,
      tabs: [
        {value: 'users', title: 'Users'},
        {value: 'stats', title: 'Stats'},
        {value: 'settings', title: 'Settings'},
        {value: 'files', title: 'Files'}
      ],
      active_tab: 'users'
    }
  },
  async mounted() {
    this.loading = true
    this.tenant = await $tenants.loadTenant(this.$route.params.id)
    this.loading = false
  },
  methods: {
    onGoToTenants() {
      $global.goToTenants()
    }
  }
}
